import React from 'react'

interface Props {}

const LandingPageStandardPartnerLogos: React.FunctionComponent<Props> = () => {
  return <>LandingPageStandardPartnerLogos</>
}

export default LandingPageStandardPartnerLogos
